<template>
  <div class="organization-dropdown" id="organization-dropdown">
    <div v-if="organizations.length" class="d-flex align-center px-5 organization-dropdown">

      <v-select
          v-if="organizations && organizations.length > 1"
          :items="sortOrganization"
          class="organization-dropdown"
          label="Organization"
          v-model="organization"
          return-object
          item-text="name"
          item-value="entity_id"
          dense
          shaped
          solo
          :menu-props="{ offsetY: true }"
          @change="changeOrganization"
      ></v-select>
      <template v-else>
        <v-text-field
          :value="organization.name"
          disabled
        >
        </v-text-field>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OrganizationDropDown',
  computed: {
    ...mapGetters(['organizations', 'currentOrganization', '_organizationLoadedItems']),
    sortOrganization () {
      const localOrgs = this.organizations
      return localOrgs.sort(function (a, b) {
        return a.name.localeCompare(b.name)
      })
    }
  },
  data () {
    return {
      organization: {}
    }
  },
  mounted () {
    this.organization = this.currentOrganization

    if (!this._organizationLoadedItems.organizations) {
      this.$store.dispatch('loadOrganizations')
      // } else {
      //   this.$store.dispatch('loadCurrentOrganization');
    }
  },
  methods: {
    changeOrganization () {
      this.$store.dispatch('changeCurrentOrganization', this.organization)
    }
  },
  watch: {
    currentOrganization () {
      if (this.$route.query && this.$route.query.scale) {
        // Check if included only digits
        const scale = /^-?\d+\.?\d*$/.test(this.$route.query.scale) ? +this.$route.query.scale : 1
        this.$store.commit('dashboardServices/SET_QUERY_SCALE', scale)
      }
      this.organization = this.currentOrganization
    }
  },
  beforeDestroy () {
    this.$store.dispatch('stopPollMonitoring')
  }
}
</script>

<style lang="scss">
.organization-dropdown {

   .v-select__selection--comma {
      color: $secondary-font-color !important;
       font-weight: bold;
       font-size: 13px;
       letter-spacing: 0.4px;
   }
  .v-input__slot {
    background: $org-drop-down !important;
    box-shadow: none !important;
    border-radius: 30px !important;

    input {
       color: $secondary-font-color !important;
       font-weight: bold;
       font-size: 13px;
    }

    .v-input--is-disabled input {
       opacity: 50%;
    }

  }
  .mdi-menu-down::before {
    content: "" !important; // drop-down icon
  }
}
</style>
